"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useAuthActions } from "@convex-dev/auth/react";
import { useConvexAuth } from "convex/react";

interface BetterEmailAuthContextValue {
  isAuthenticated: boolean;
  isLoading: boolean;
  signOut: () => Promise<void>;
}

const BetterEmailAuthContext = createContext<BetterEmailAuthContextValue | undefined>(undefined);

export function BetterEmailAuthProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useConvexAuth();
  const { signOut } = useAuthActions();

  return (
    <BetterEmailAuthContext.Provider value={{ isAuthenticated, isLoading, signOut }}>
      {children}
    </BetterEmailAuthContext.Provider>
  );
}

export function useBetterEmailAuth() {
  const context = useContext(BetterEmailAuthContext);
  if (!context) {
    throw new Error("useBetterEmailAuth must be used within BetterEmailAuthProvider");
  }
  return context;
}
